import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export type UDImageSize = 'sm' | 'md' | 'lg';

export const sizeMap: Record<UDImageSize, number> = {
  sm: 24,
  md: 40,
  lg: 56,
};

type UDImageStyledProps = {
  backgroundUrl: string;
  sizePx: number;
};

export const UDImageStyled = styled.div<UDImageStyledProps>`
  width: ${(props) => props.sizePx}px;
  height: ${(props) => props.sizePx}px;
  min-width: ${(props) => props.sizePx}px;
  min-height: ${(props) => props.sizePx}px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.SurfaceCultured10};
  overflow: clip;
  background-image: url('${(props) => props.backgroundUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-origin: content-box;
`;
